// extracted by mini-css-extract-plugin
module.exports = {"upperTitle":"Title_upperTitle__28dE4","mainTitle":"Title_mainTitle__OB8-X"};